import { Base } from './permission/base';
import { Task } from './permission/task';

export class UserPermissions {
   //roles
   isPropAdmin?: boolean;
   isBillingAdmin?: boolean;
   //permissions
   role: Base;
   user: Base;
   taskManagement: Base;
   tasks: Task;
   forms: Base;
   property: Base;
   groups: Base;
   reports: Base;
   search: Base;
   billing: Base;
   hasAudit?: boolean;
   hasCreateAudit?: boolean;
   hasWorkflow?: boolean;
   hasWorkflowRun?: boolean;

   constructor() {
      this.role = new Base('roles');
      this.user = new Base('users');
      this.forms = new Base('forms');
      this.groups = new Base('groups');
      this.reports = new Base('reports');
      this.property = new Base('property');
      this.taskManagement = new Base('taskmgmt');
      this.tasks = new Task();
      this.property = new Base('property');
      this.search = new Base('search');
      this.billing = new Base('billing');
   }

   updatePermissions(permissions: string): void {
      this.role.updatePermissions(permissions);
      this.user.updatePermissions(permissions);
      this.tasks.updatePermissions(permissions);
      this.forms.updatePermissions(permissions);
      this.groups.updatePermissions(permissions);
      this.reports.updatePermissions(permissions);
      this.taskManagement.updatePermissions(permissions);
      this.search.updatePermissions(permissions);
      this.billing.updatePermissions(permissions);
   }

   hasSuperAdmin() {
      return this.user.super || this.forms.super || this.property.super;
   }

   get isAccountOwner(): boolean {
      // admin:billing
      const hasBilling = !!this.isBillingAdmin;

      // users: read/create/update/delete
      const usersOK =
         this.user.read && this.user.create && this.user.update && this.user.delete;

      // groups: read/create/update  (no delete:groups required)
      const groupsOK = this.groups.read && this.groups.create && this.groups.update;

      // roles: read/create/update/delete
      const rolesOK =
         this.role.read && this.role.create && this.role.update && this.role.delete;

      // taskmgmt: read/create/update/delete
      const taskMgmtOK =
         this.taskManagement.read &&
         this.taskManagement.create &&
         this.taskManagement.update &&
         this.taskManagement.delete;

      return hasBilling && usersOK && groupsOK && rolesOK && taskMgmtOK;
   }
}
